export const rateTableWidth = 200;
